import React, { useState } from 'react';
import { Space, Button, Input, Select, DatePicker, Table } from 'tt-ui-lib/core';
import { SearchIcon } from 'tt-ui-lib/icons';
import styles from '../../Communications.module.scss';
import CreateNewsletterModal from '../modals/CreateNewsletter';

const UsersTab = () => {
  const columns = [
    { key: 'checkbox', dataIndex: 'checkbox', title: '', width: '50px' },
    { key: 'name', dataIndex: 'name', title: 'Username' },
    { key: 'email', dataIndex: 'email', title: 'Email' },
    { key: 'phone', dataIndex: 'phone', title: 'Phone' },
    { key: 'roles', dataIndex: 'roles', title: 'Roles' },
    { key: 'createdAt', dataIndex: 'createdAt', title: 'Registration date' },
    { key: 'status', dataIndex: 'status', title: 'Status' },
  ];

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openCreateNewsletterModal, setOpenCreateNewsletterModal] = useState(false);

  return (
    <>
      <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <b>Total found: {data.length}</b>
        <Button type="primary" onClick={() => setOpenCreateNewsletterModal(true)}>
          Create a newsletter
        </Button>
      </Space>

      <Space className={styles.filter}>
        <Input
          placeholder="Search"
          prefix={<SearchIcon style={{ width: '20px', height: '20px' }} />}
          style={{ width: '100%' }}
        />
        <Select options={[]} placeholder="Sort by" style={{ width: '100%' }} />
        <DatePicker placeholder="Registration period" style={{ width: '100%' }} />
        <Select options={[]} placeholder="Status" style={{ width: '100%' }} />
        <Select options={[]} placeholder="Role" style={{ width: '100%' }} />
      </Space>

      <Table data={data} columns={columns} loading={isLoading} />

      <CreateNewsletterModal
        open={openCreateNewsletterModal}
        setOpen={setOpenCreateNewsletterModal}
      />
    </>
  );
};

export default UsersTab;
